import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { saveAccountDetailSuccess } from 'src/app/pages/account-details/state/account-detail.actions';
import { AccountOption } from 'src/app/pages/account-register/models/account-option.interface';
import { createAccountSuccess } from 'src/app/pages/add-account/state/add-account.actions';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { accountOptionActions } from './account-option.actions';

export const accountOptionFeatureKey = 'accountOptions';

export type AccountOptionState = EagerSelectState<AccountOption>;

const adapter = createEagerSelectAdapter<AccountOptionState, AccountOption>({
   featureKey: accountOptionFeatureKey,
   selectId: (account: AccountOption) => {
      return account.accountId;
   },
});

function filterAccountOption(
   accounts: AccountOption[],
   searchText: string | null | undefined
): AccountOption[] {
   const searchTerm = searchText?.trim().toUpperCase();

   if (!searchTerm) {
      return accounts;
   }

   return accounts.filter((account) => {
      const nameMatches = account.name?.toUpperCase().includes(searchTerm) ?? false;
      const companyCodeMatches = account.shortName?.toUpperCase().includes(searchTerm) ?? false;

      return nameMatches || companyCodeMatches;
   });
}

export const accountOptionSelectors = adapter.getSelectors(filterAccountOption);

const initialState = adapter.getInitialState();

export const accountOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   accountOptionActions.search,
   accountOptionActions.searchReset,
   accountOptionActions.loadFromApi,
   accountOptionActions.loadFromApiSuccess,
   accountOptionActions.loadFromApiFailure,
   null,
   on(createAccountSuccess, saveAccountDetailSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);
